import { AssessmentCoreBase } from "./assessment.core.base"


export class AssessmentCore extends AssessmentCoreBase {

}